import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, FreeMode, Thumbs } from 'swiper/modules';
export default class Banner {
    constructor() {
        this.section = document.querySelector('.banner');
        
        this.slider = this.section.querySelector('.swiper--banner');
        this.navigationPrev = document.querySelector('.slider-button-prev--banner');
        this.navigationNext = document.querySelector('.slider-button-next--banner');

        this.sliderThumbs = this.section.querySelector('.swiper--banner-thumbs');
        this.sliderThumbsWrapper = this.section.querySelector('.swiper--banner-thumbs .swiper-wrapper');

        this.ready();
    }

    ready() {

        const allSlliders = this.slider.querySelectorAll('.swiper-slide')
        allSlliders.forEach((el, index) => {
            this.sliderThumbsWrapper.innerHTML += this.templateThumbs(index +1, el.dataset.frase)
        })

        const swiperThumbs = new Swiper(this.sliderThumbs, {
            modules: [FreeMode],
            spaceBetween: 0,
            slidesPerView: 4,
            freeMode: true,
            grabCursor: false,
            watchSlidesProgress: true,
        })

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination, Thumbs],
            grabCursor: false,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            thumbs: {
                swiper: swiperThumbs,
            },
            on: {
                init: (sw) => {
                    document.addEventListener('DOMContentLoaded', () => {
                        this.updateLazyVideo(sw, this.slider);
                    });
                },
                slideChange: (sw) => {
                    this.updateLazyVideo(sw, this.slider);
                },
            },
        });
    }

    templateThumbs(numero, frase) {
        const template = `
            <div class="swiper-slide group hover:cursor-pointer">
                <div class="bg-light dark:bg-black flex flex-row px-[1.875rem] py-3 w-full group-[.swiper-slide-thumb-active]:bg-unigreen500 dark:group-[.swiper-slide-thumb-active]:bg-dark group-hover:bg-unigreen500 transition-all">
                    <div class="flex text-unigreen dark:text-white text-sm leading-4 transform-[0.2em] mt-1 group-[.swiper-slide-thumb-active]:text-white group-hover:text-white">${numero}</div>
                    <div class="flex w-px h-[3.25rem] bg-unigreen dark:bg-white mx-3 group-[.swiper-slide-thumb-active]:bg-white  group-hover:bg-white"></div>
                    <div class="text-sm leading-6 text-unigreen dark:text-white group-[.swiper-slide-thumb-active]:text-white group-hover:text-white">${frase}</div>
                </div>
            </div>
        `;
        return template
    }
    
    updateLazyVideo(sw, rootComponent) {
        const videoSources = rootComponent.querySelectorAll('video source');
        videoSources.forEach((elem) => {
            elem.setAttribute('src', '');
        });
    
        const current = rootComponent.querySelector('.swiper-slide:nth-child(' + (sw.activeIndex + 1) + ')');
        if (current && current.querySelector('video')) {
            const video = current.querySelector('video source');
    
            if (video) {
                video.setAttribute('src', video.dataset.src);
                current.querySelector('video').load();
            }
        }
    }
}

if (document.querySelector('.banner')) {
    new Banner();
}